import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { generateChecksum } from "../middleware/generateChecksum";

export const eligibilityApi = createApi({
  reducerPath: "eligibilityApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL + "/v2/api/",
  }),
  endpoints: (builder) => ({
    getBasicDetails: builder.mutation({
      query: (data) => {
        const body = new URLSearchParams({
          mode: "get_customer_details",
          phone: localStorage.getItem("phone") || "",
          checksum: generateChecksum({
            mode: "get_customer_details",
            phone: localStorage.getItem("phone") || "",
          }),
        }).toString();

        return {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            secret: data.scrt,
            jwt_token: data.jwt_token,
          },
          body,
        };
      },
    }),
    updateBasicDetails: builder.mutation({
      query: (data) => {
        const body = {
          mode: "set_customer_details",
          name: data.name,
          pan_number: data.pan_number,
          dob: data.dob,
          pin_code: data.pin_code,
          email: data.email,
          consent: data.consent || "1",
          phone: data.phone,
          partner_unique_id: data.partner_unique_id || null,
        };
        const checksum = generateChecksum(body);

        return {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            secret: data.scrt,
            jwt_token: data.jwt_token,
          },
          body: new URLSearchParams({ ...body, checksum }).toString(),
        };
      },
    }),
    updateTnC: builder.mutation({
      query: (data) => {
        const body = {
          mode: "tnc_acceptance",
          device_id: data.device_id,
          accept_status: data.accept_status,
        };
        const checksum = generateChecksum(body);

        return {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            secret: data.scrt,
            jwt_token: data.jwt_token,
          },
          body: new URLSearchParams({ ...body, checksum }).toString(),
        };
      },
    }),
    getLocLimit: builder.mutation({
      query: (data) => {
        const body = new URLSearchParams({
          mode: data.mode || "get_loc_limit",
          checksum: data.checksum,
        }).toString();

        return {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            secret: data.scrt,
            jwt_token: data.jwt_token,
          },
          body,
        };
      },
    }),
    unlockLocLimit: builder.mutation({
      query: (data) => {
        const body = new URLSearchParams({
          mode: "unlock_limit",
          checksum: generateChecksum({ mode: "unlock_limit" }),
        }).toString();

        return {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            secret: data.scrt,
            jwt_token: data.jwt_token,
          },
          body,
        };
      },
    }),
    getAmountSelection: builder.mutation({
      query: (data) => {
        const body = new URLSearchParams({
          mode: "amount_selection",
          checksum: generateChecksum({ mode: "amount_selection" }),
        }).toString();

        return {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            secret: data.scrt,
            jwt_token: data.jwt_token,
          },
          body,
        };
      },
    }),
    submitAmountSelection: builder.mutation({
      query: (data) => {
        const consentsStr = typeof data.consents === 'string'
          ? data.consents
          : JSON.stringify(data.consents ?? []);
        const body = new URLSearchParams({
          mode: "amount_submission",
          selected_amount: data.amount,
          checksum: generateChecksum({
            mode: "amount_submission",
            selected_amount: data.amount,
            consents: consentsStr,
          }),
          consents: consentsStr,
        }).toString();

        return {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            secret: data.scrt,
            jwt_token: data.jwt_token,
          },
          body,
        };
      },
    }),
    getPartnerLoc: builder.mutation({
      query: (data) => {
        /*const body = new URLSearchParams({
                    mode: 'amount_submission',
                    selected_amount: data.amount,
                    checksum: generateChecksum({ mode: 'amount_submission', selected_amount: data.amount }),
                }).toString();
                const body = {
                    credit_shield_enable: true,
                    pcr_enable: true,
                    amount: data.amount,
                    is_fip: true,
                    gateway_type: "",
                    credit_shield_opt: false,
                    tenure: data.amount,
                    pcr_opt: false,
                    gateway_enable: 0
                }*/

        const addon_params = `&credit_shield_enable=${data.credit_shield_enable}&pcr_enable=${data.pcr_enable}&credit_shield_opt=${data.credit_shield_opt}&pcr_opt=${data.pcr_opt}`;

        return {
          method: "GET",
          url: `${process.env.REACT_APP_API_URL}/customers/v1/disbursal/get-loan-details?jwt_token=${data.jwt_token}&secret=${data.scrt}&utm_source=${data.utmSource}${addon_params}`,
          headers: {
            //'Content-Type': 'application/json',
            //secret: data.scrt,
            //auth_token: data.jwt_token,
            //device_id: data.device_id
          },
          //body,
        };
      },
    }),
    getPartnerLocConfirm: builder.mutation({
      query: (data) => {
        const body = {
          amount: data.amount,
          credit_report_fees: data.credit_report_fees,
          gateway_type: "",
          early_foreclosure_fee: data.early_foreclosure_fee,
          is_fcp: data.is_fcp,
          txn_id: data.txn_id,
          is_fip: data.is_fip,
          max_amount: 0.0,
          gateway_fees: null,
          tenure: data.tenure,
          plan_id: data.plan_id,
        };

        return {
          method: "POST",
          url: `${process.env.REACT_APP_API_URL}/customers/v1/journey/get-partner-loc-confirm`,
          headers: {
            "Content-Type": "application/json",
            secret: data.scrt,
            auth_token: data.jwt_token,
            device_id: data.device_id,
          },
          body,
        };
      },
    }),
    getLoanbankDetails: builder.mutation({
      query: (data) => {
        return {
          method: "GET",
          url: `${process.env.REACT_APP_API_URL}/customers/v1/disbursal/bank-details?jwt_token=${data.jwt_token}&secret=${data.scrt}&utm_source=${data.utmSource}`,
          headers: {
            "Content-Type": "application/json",
          },
        };
      },
    }),
    loanSummary: builder.mutation({
      query: (data) => {
        const body = {
          mode: "loan_summary",
        };
        const checksum = generateChecksum(body);

        return {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            secret: data.scrt,
            auth_token: data.jwt_token,
          },
          body: new URLSearchParams({ ...body, checksum }).toString(),
        };
      },
    }),
    DisburseNextEmi: builder.mutation({
      query: (data) => {
        return {
          method: "GET",
          url: `${process.env.REACT_APP_API_URL}/customers/v1/disbursal/next-emi-details?jwt_token=${data.jwt_token}&secret=${data.scrt}&utm_source=${data.utmSource}`,
          headers: {
            "Content-Type": "application/json",
          },
        };
      },
    }),
    DisbursalDisburse: builder.mutation({
      query: (data) => {
        const body = {
          max_amount: data.max_amount,
          credit_report_fees: data.credit_report_fees,
          plan_id: data.plan_id,
          consent: data?.consent,
        };
        return {
          method: "POST",
          url: `${process.env.REACT_APP_API_URL}/customers/v1/disbursal/disburse?jwt_token=${data.jwt_token}&secret=${data.scrt}&utm_source=${data.utmSource}`,
          headers: {
            auth_token: data.jwt_token,
            device_id: data.deviceid,
          },
          body,
        };
      },
    }),
    setUpAutopay: builder.mutation({
      query: (data) => {
        debugger;
        const body = {
          mode: "get_auto_pay",
        };
        const checksum = generateChecksum(body);

        return {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            secret: data.scrt,
            jwt_token: data.jwt_token,
          },
          body: new URLSearchParams({ ...body, checksum }).toString(),
        };
      },
    }),
    getBankMandate: builder.mutation({
      query: (data) => {
        return {
          method: "GET",
          url: `${process.env.REACT_APP_API_URL}/customers/v1/get-nach-details`,
          headers: {
            jwt_token: data.jwt_token,
            device_id: data.deviceid,
            secret: data.scrt,
          },
        };
      },
    }),
    getCustomerFeatureFlag: builder.mutation({
      query: (data) => {
        const body = new URLSearchParams({
          mode: "customer_feature_flag",
          checksum: generateChecksum({ mode: "customer_feature_flag" }),
        }).toString();

        return {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            secret: data.scrt,
            jwt_token: data.jwt_token,
          },
          body,
        };
      },
    }),
    getRpdPolling: builder.mutation({
      query: (data) => {
        return {
          method: "GET",
          url: `${process.env.REACT_APP_API_URL}/customers/v1/journey/partners-rpd-polling`,
          headers: {
            "Content-Type": "application/json",
            secret: data.scrt,
            auth_token: data.jwt_token,
          },
        };
      },
    }),
    getCustomerDetails: builder.mutation({
      query: (data) => {
        return {
          method: "GET",
          url: `${process.env.REACT_APP_API_URL}/customers/v1/journey/customer?jwt_token=${data.jwt_token}&secret=${data.scrt}`,
          headers: {
            "Content-Type": "application/json",
            secret: data.scrt,
            auth_token: data.jwt_token,
          },
        };
      },
    }),
    dobMatch: builder.mutation({
      query: (data) => {
        return {
          method: "GET",
          url: `${process.env.REACT_APP_API_URL}/customers/v1/webjourney/dob-match?jwt_token=${data.jwt_token}&secret=${data.scrt}`,
          headers: {
            "Content-Type": "application/json",
            secret: data.scrt,
            auth_token: data.jwt_token,
          },
        };
      },
    }),
    dobUpdate: builder.mutation({
      query: (data) => {
        const body = {
          dob: data.dob,
        };
        return {
          method: "POST",
          url: `${process.env.REACT_APP_API_URL}/customers/v1/webjourney/dob-update?jwt_token=${data.jwt_token}&secret=${data.scrt}`,
          headers: {
            "Content-Type": "application/json",
            secret: data.scrt,
            auth_token: data.jwt_token,
          },
          body,
        };
      },
    }),
  }),
});

export const {
  useGetBasicDetailsMutation,
  useUpdateBasicDetailsMutation,
  useUpdateTnCMutation,
  useGetLocLimitMutation,
  useUnlockLocLimitMutation,
  useGetAmountSelectionMutation,
  useSubmitAmountSelectionMutation,
  useGetPartnerLocMutation,
  useGetPartnerLocConfirmMutation,
  useGetLoanbankDetailsMutation,
  useLoanSummaryMutation,
  useDisburseNextEmiMutation,
  useDisbursalDisburseMutation,
  useSetUpAutopayMutation,
  useGetBankMandateMutation,
  useGetCustomerFeatureFlagMutation,
  useGetRpdPollingMutation,
  useGetCustomerDetailsMutation,
  useDobMatchMutation,
  useDobUpdateMutation,
} = eligibilityApi;
